import { z } from "zod";
import { LocalizedTextSchema, idPattern } from "./common.js";

export const ItemKindSchema = z.enum([
  "speedup",
  "resource_crate",
  "xp",
  "cdc",
  "fragment",
  "ufr",
  "fab",
  "ffab",
  "stamina",
  "shield",
  "teleport",
  "skin",
  "token",
  "chest",
  "nano",
  "blueprint",
  "drone_core",
  "sweep",
  "decoration",
]);
export type ItemKind = z.infer<typeof ItemKindSchema>;

export const ItemDefSchema = z.object({
  id: idPattern("itm"),
  kind: ItemKindSchema,
  name: LocalizedTextSchema,
  params: z.record(z.string(), z.union([z.number(), z.string()])),
  /** Reference value in Credits, used for "worth X ₵" ribbons and telemetry. */
  refPrice: z.number().min(0),
  stackable: z.boolean(),
});
export type ItemDef = z.infer<typeof ItemDefSchema>;
